import { render, staticRenderFns } from "./AudienceData.vue?vue&type=template&id=5b284e08&scoped=true&"
import script from "./AudienceData.vue?vue&type=script&lang=js&"
export * from "./AudienceData.vue?vue&type=script&lang=js&"
import style0 from "./AudienceData.vue?vue&type=style&index=0&id=5b284e08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b284e08",
  null
  
)

export default component.exports